
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/wallet",
      function () {
        return require("private-next-pages/dashboard/wallet/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard/wallet"])
      });
    }
  